import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layout/components/AppCard";
import MakeProduct from "./MakeProduct";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";
import {isAdmin} from "../../../../config/Permissions";
import {ArrowLeft, ChevronLeft} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {IconButton} from "@mui/material";



function OrganizationsPage({create}){
    const { t } = useTranslation();
    const navigation = useNavigate();

    const handleGoBack = () => {
        if(!!isAdmin()){
            navigation(`/panel/manage/products/view-all`);
        }else{
            navigation(`/panel/vendor/products/view-all`);
        }
    }
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={!!create ? t('addProduct') : t('editProduct')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12} >
                    <div className="d-flex mb-15" style={{gap:10}}>
                        <IconButton
                            color="primary"
                            onClick={() => handleGoBack()}
                        >
                            <ArrowLeft className={"lucide-icon-default"}/>
                        </IconButton>
                        <Title align="left" color="text" className="mb-0 title-app">{!!create ? t('addProduct') : t('editProduct')}</Title>
                    </div>
                    <MakeProduct create={create}/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(OrganizationsPage);
